import areaStroe from './areaStore';

let index = 0;

export default {
  install(store, attrs) {
    let name = attrs.name ? attrs.name : 'Da' + index++;
    if (!store.state.base) {
      store.registerModule(['base'], {
        state: {},
      });
    }
    if (!store.state.base['dashboardArea' + name]) {
      store.registerModule(['base', 'dashboardArea' + name], areaStroe);
    }
    return name;
  },
  uninstall(store, index) {
    store.unregisterModule(['base', 'dashboardArea' + index]);
  },
};
